import { customerOperationsOpaqueIdSchema } from "@lifescapsule/contracts";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuthSession } from "./AuthSession";
import { observeStudioSession } from "./customer-activity";

const observedStudioKey = (bookId: string) => `lifescapsule:observed-studio-session:${bookId}`;

/**
 * Tells operations a member opened a book to work on it: once per book per browser tab, so
 * moving between steps or refreshing never counts again (journey audit, 2026-10-16: the event
 * existed but nothing sent it). Renders nothing, and never affects the page if it fails.
 */
export function StudioSessionObservation() {
  const { bookId = "" } = useParams<{ bookId: string }>();
  const idToken = useAuthSession().tokens?.idToken;

  useEffect(() => {
    if (!idToken || !customerOperationsOpaqueIdSchema.safeParse(bookId).success) return;
    const key = observedStudioKey(bookId);
    try {
      if (sessionStorage.getItem(key)) return;
      // Reserved before the request, so Strict Mode and quick re-renders send it once.
      sessionStorage.setItem(key, "1");
    } catch {
      // With storage blocked it may be sent more than once, which only over-counts sessions.
    }
    void observeStudioSession(idToken, bookId).then((accepted) => {
      if (accepted) return;
      try {
        sessionStorage.removeItem(key);
      } catch {
        // Observability is best effort.
      }
    });
  }, [bookId, idToken]);

  return null;
}
